import loadable from '@loadable/component';

export const HomebuildingSiteWrapper = loadable(
  () => import(/* webpackChunkName: "homebuilding-site" */ './HomebuildingSiteWrapper'),
);
